import { useParams } from "react-router-dom";
import { RollupDashboard } from "../../components/RollupDashboard";

export function EnterpriseDashboard() {
  const { id } = useParams();
  return (
    <RollupDashboard
      scopeType="enterprise"
      scopeId={Number(id)}
      title={`Enterprise #${id}`}
      subtitle="All states + districts + godowns."
    />
  );
}
